
function NavbarDownloadSection() {
    return <div className="flex space-x-4 flex-end ml-auto mr-20">
        <a href="./login" className="text-md text-white bg-stop-it-red hover:text-stop-it-red border-2 py-0/5 hover:bg-white cursor-pointer border-stop-it-red px-4 rounded-lg ml-auto justify-end ml-auto">Login</a>
        <img class='w-4 h-4 place-self-center cursor-pointer' src="./apple.svg" alt='apple app store link' />
        <img class='w-4 h-4 place-self-center cursor-pointer' src="./google-play.svg" alt='google play store link' />
    </div>;
}

export default NavbarDownloadSection;